var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPeople(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 125,
    viewBox: "0 0 110 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.633 65.991c16.055 0 29.067-13.012 29.067-29.067S74.688 7.858 58.633 7.858 29.567 20.869 29.567 36.924s13.011 29.067 29.066 29.067zm20.347 7.267h-3.792a39.573 39.573 0 01-16.555 3.633c-5.904 0-11.49-1.317-16.554-3.633h-3.792c-16.85 0-30.52 13.67-30.52 30.52v9.446c0 6.018 4.882 10.9 10.9 10.9H98.6c6.018 0 10.9-4.882 10.9-10.9v-9.446c0-16.85-13.67-30.52-30.52-30.52z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.367 58.724c16.054 0 29.066-13.012 29.066-29.066C80.433 13.602 67.421.59 51.367.59 35.312.59 22.3 13.603 22.3 29.657c0 16.055 13.012 29.067 29.067 29.067zm20.346 7.267h-3.792a39.572 39.572 0 01-16.554 3.633c-5.904 0-11.49-1.317-16.555-3.633H31.02C14.17 65.99.5 79.66.5 96.51v9.446c0 6.018 4.882 10.9 10.9 10.9h79.933c6.018 0 10.9-4.882 10.9-10.9v-9.446c0-16.85-13.67-30.52-30.52-30.52z",
    fill: "#EAECF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPeople);
export default __webpack_public_path__ + "static/media/no-people.7f0b4c4cbde918b5a08404ce61bb244f.svg";
export { ForwardRef as ReactComponent };